export abstract class Filter {
  filterName = "";

  protected constructor(name: string) {
    this.filterName = name;
  }

  public getFilterName(): string {
    return this.filterName;
  }
  /**
   * Tworzy string, ktory posluzy jako queryParam w urlu
   */
  public abstract toQueryParam(): string;

  public abstract clear(): void;

  /**
   * Metoda slużąca do przejęcia propsow obiektu js.
   * Przykład dostajemy nowy filtr z urla jako czysty obiekt js, a chcemy by zachowal metode tej klasy np. toQueryParam
   * @param source filtr, ktorego pola ma przejać instacja tej klasy
   */
  public copyInto(source: Record<string, unknown>): void {
    Object.assign(this, source);
  }
}
